import React from 'react';

import NoItemsIcon from '../../assets/ES_NoItems.svg';
import NoResultsIcon from '../../assets/ES_NoResults.svg';
import ErrorIcon from '../../assets/ES_ErrorIcon.svg';
import AllFilteredIcon from '../../assets/ES_AllFiltered.svg';
import EmptyBoxIcon from '../../assets/ES_EmptyBox.svg';
import NoEmployees from '../../assets/ES_NoEmployees.svg';
import NoEntChannels from '../../assets/ES_NoEntChannels.svg';
import EmptyTagsIcon from '../../assets/Empty_Tags_Icon.svg';
import EmptySocialIcon from '../../assets/ES_Social.svg';

import packageInfo from '../../../package.json';
const { version } = packageInfo;

import './EmptyState.scss';
import { Button } from '@mui/material';

const defaultErrorAction = (
    <Button
        key='default-error-button'
        variant="contained"
        color="primary"
        className="button err-boundary-reload-btn"
        onClick={() => window.location.reload()}>
        Try Again
    </Button>
);

const EMPTY_STATE_TYPE = {
    EMPTY_LIST: {
        icon: NoItemsIcon,
        title: "You don't have any elements!",
        message: "",
        actions: []
    },
    NO_RESULTS: {
        icon: NoResultsIcon,
        title: "No results matching",
        message: "Please check spelling or try searching with another word.",
        actions: []
    },
    NO_FILTERED_RESULTS: {
        icon: AllFilteredIcon,
        title: "No results were found",
        message: "Try adjusting your filter to find what you are looking for.",
        actions: []
    },
    ERROR: {
        icon: ErrorIcon,
        title: "Something went wrong",
        message: "Try reloading or return to homepage.",
        actions: [defaultErrorAction]
    },
    NO_UPDATES: {
        icon: EmptyBoxIcon,
        actions: []
    },
    NO_ITEM_SELECTED: {
        icon: null,
        title: "No item selected",
        message: "Select an item from the list and it will show here.",
        actions: []
    },
    NO_EMPLOYEES: {
        icon: NoEmployees,
        title: "Nothing here yet",
        message: "No employees to show",
        actions: []
    },
    NO_COMMENTS: {
        icon: NoEmployees,
        title: "Nothing here yet",
        message: "No comments to show",
        actions: []
    },
    NO_ENTERTAINMENT_CHANNELS: {
        icon: NoEntChannels,
        title: "No channels or games match this category.",
        message: "Try a different category or use the search box to continue discovering content.",
        actions: []
    },
    NO_LABELS: {
        icon: EmptyTagsIcon,
        title: "No Labels in this Organization.",
        actions: []
    },
    NO_SOCIAL_SOURCES: {
        icon: EmptySocialIcon,
        title: "You don’t have Social Content enabled yet!",
        message: "Activate Direct Share or connect an Instagram Business Account to start sharing and engaging with your audience.",
        actions: []
    },
    NO_SOCIAL_CONTENT: {
        icon: EmptyBoxIcon,
        title: "You don’t have Social Posts yet!",
        message: "A call to action encouraging patrons to post will appear on your screen until you start receiving photos.",
        actions: []
    },
    NO_CAMPAIGNS: {
        icon: EmptyBoxIcon,
        title: 'You don\'t have any QR Campaigns!',
        message: 'Create your first QR Campaign to collect and track performance of your TV or print assets.',
        actions: [],
    }
}

const EmptyState = props => {
    const { type = 'EMPTY_LIST', icon, title, message, actions, height = "100%", width = "100%" } = props;

    const DEFAULT_EMPTY_STATE = EMPTY_STATE_TYPE[type] ?? EMPTY_STATE_TYPE.EMPTY_LIST;

    return (
        <div className={`EmptyState ${type.toLowerCase()}`} style={{ height, width }}>
            {(!!icon || !!DEFAULT_EMPTY_STATE.icon) &&
                <img src={icon || DEFAULT_EMPTY_STATE.icon} alt='Icon' />}
            <h1 className='title'>{title || DEFAULT_EMPTY_STATE.title}</h1>
            <div className='message'>{message || DEFAULT_EMPTY_STATE.message}</div>
            <div className='buttons-container'>
                {!!actions ? actions : DEFAULT_EMPTY_STATE.actions}
            </div>
            {type === 'ERROR' && <div className='version'>v{version}</div>}
        </div>
    );
}

export default EmptyState;
